/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';

export default (set, get, dimensions) => set(produce(get(), (draft) => {
  if (!draft.skuDimensions) {
    draft.skuDimensions = {};
  }
  draft.skuDimensions = dimensions;
}), false,
{ type: 'INITIALIZE_SKU_DIMENSIONS', payload: dimensions },
);
